export default function Footer() {
  const currentYear = new Date().getFullYear();

  const socialLinks = [
    { icon: 'ri-linkedin-fill', url: '#', label: 'LinkedIn' },
    { icon: 'ri-twitter-x-fill', url: '#', label: 'Twitter' },
    { icon: 'ri-instagram-fill', url: 'https://www.instagram.com/yepesweblab', label: 'Instagram' },
    { icon: 'ri-github-fill', url: '#', label: 'GitHub' },
    { icon: 'ri-dribbble-fill', url: '#', label: 'Dribbble' }
  ];

  return (
    <footer className="bg-[#182114] py-16 px-6 border-t-2 border-[#2E3F25]">
      <div className="max-w-7xl mx-auto">
        {/* Top section */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Brand */}
          <div>
            <div className="text-5xl font-bold text-[#D96B33] mb-4 tracking-tighter" style={{ fontFamily: '"Distro Bold", sans-serif' }}>
              WY
            </div>
            <p className="text-[#EBEBE0]/70 leading-relaxed" style={{ fontFamily: '"Century Gothic", sans-serif' }}>
              We are not another boring tech company. We're your creative technology partner, building the future one project at a time.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-xl font-bold text-white mb-4" style={{ fontFamily: '"Distro Bold", sans-serif' }}>
              Quick Links
            </h3>
            <ul className="space-y-3">
              {['About Us', 'Services', 'Portfolio', 'Process', 'Contact'].map((link) => (
                <li key={link}>
                  <a
                    href={`#${link.toLowerCase().replace(' ', '-')}`}
                    className="text-[#EBEBE0]/70 hover:text-[#D96B33] transition-colors duration-300 cursor-pointer inline-flex items-center gap-2 group"
                    style={{ fontFamily: '"Century Gothic", sans-serif' }}
                  >
                    <i className="ri-arrow-right-s-line text-lg group-hover:translate-x-1 transition-transform"></i>
                    {link}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Connect */}
          <div>
            <h3 className="text-xl font-bold text-white mb-4" style={{ fontFamily: '"Distro Bold", sans-serif' }}>
              Connect With Us
            </h3>
            <p className="text-[#EBEBE0]/70 mb-6" style={{ fontFamily: '"Century Gothic", sans-serif' }}>
              Follow our journey and stay updated with our latest projects.
            </p>
            <div className="flex gap-4">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.url}
                  aria-label={social.label}
                  className="w-12 h-12 bg-[#2E3F25] rounded-full flex items-center justify-center text-[#EBEBE0] hover:bg-[#D96B33] hover:text-white transition-all duration-300 hover:scale-110 cursor-pointer"
                >
                  <i className={`${social.icon} text-xl`}></i>
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="h-px bg-gradient-to-r from-transparent via-[#2E3F25] to-transparent mb-8"></div>

        {/* Bottom section */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-[#EBEBE0]/60 text-sm" style={{ fontFamily: '"Century Gothic", sans-serif' }}>
            © {currentYear} Yepes WebLab. All rights reserved.
          </p>
          
          <div className="flex items-center gap-6">
            <a
              href="#"
              className="text-[#EBEBE0]/60 hover:text-[#D96B33] transition-colors duration-300 text-sm cursor-pointer"
              style={{ fontFamily: '"Century Gothic", sans-serif' }}
            >
              Privacy Policy
            </a>
            <a
              href="#"
              className="text-[#EBEBE0]/60 hover:text-[#D96B33] transition-colors duration-300 text-sm cursor-pointer"
              style={{ fontFamily: '"Century Gothic", sans-serif' }}
            >
              Terms of Service
            </a>
            <a
              href="https://readdy.ai/?origin=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#EBEBE0]/60 hover:text-[#D96B33] transition-colors duration-300 text-sm cursor-pointer"
              style={{ fontFamily: '"Century Gothic", sans-serif' }}
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
